import { useState } from "react";
import { useIsSmallScreen } from "./App";
import { NewButton } from "./NewButton";
import { NewCelebrationList } from "./NewCelebrationList";
import { Celebration } from "./calendar/ordinariate-calendar";

const getOAntiphonTitle = (month: number, date: number) => {
    if (month === 12) {
        if (date === 17) return "(O Sapientia)";
        if (date === 18) return "(O Adonai)";
        if (date === 19) return "(O Radix Jesse)";
        if (date === 20) return "(O Clavis David)";
        if (date === 21) return "(O Oriens)";
        if (date === 22) return "(O Rex Gentium)";
        if (date === 23) return "(O Emmanuel)";
    }

    return "";
};

export const OfficesOfTheDayView = (props: {
    year: number;
    month: number;
    date: number;
    day: string;
    morningOptions: Celebration[];
    morningOutranked: Celebration[];
    eveningOptions: Celebration[];
    eveningOutranked: Celebration[];
    isSelected: boolean;
    transferNotes: string[];
    isFirstEvensong: string[];
    setDate: (newDate: Date) => void;
}) => {
    const isToday =
        props.date === new Date().getDate() &&
        props.month === new Date().getMonth() + 1 &&
        props.year === new Date().getFullYear();

    const [hour, setHour] = useState(
        isToday
            ? new Date().getHours() > 12
                ? "evening"
                : "morning"
            : "mattins"
    );

    const votivesNotAllowedReason: string | undefined = [
        {
            label: "on Solemnities",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find(
                    (celebration) => celebration.type === "solemnity"
                ),
        },
        {
            label: "on Sundays of Advent",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find((celebration) =>
                    celebration.title.includes("Sunday of Advent")
                ),
        },
        {
            label: "on Sundays in Lent",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find((celebration) =>
                    celebration.title.includes("Sunday in Lent")
                ),
        },
        {
            label: "on Sundays of Easter",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find((celebration) =>
                    celebration.title.includes("Sunday of Easter")
                ),
        },
        {
            label: "on Ash Wednesday",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find((celebration) =>
                    celebration.title.includes("Ash Wednesday")
                ),
        },
        {
            label: "in Holy Week",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find(
                    (celebration) =>
                        celebration.title.includes("Holy Week") ||
                        celebration.title.includes("Maundy Thursday") ||
                        celebration.title.includes("Good Friday") ||
                        celebration.title.includes("Holy Saturday")
                ),
        },
        {
            label: "in the Octave of Easter",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find((celebration) =>
                    celebration.title.includes("Octave of Easter")
                ),
        },
        {
            label: "in the Octave of Pentecost",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find((celebration) =>
                    celebration.title.includes("in Whitsun Week")
                ),
        },
        {
            label: "on 2 November",
            check: (celebrationList: Celebration[]) =>
                celebrationList.find((celebration) =>
                    celebration.title.includes("All Souls")
                ),
        },
    ].find((reason) => reason.check(props.morningOptions))?.label;

    return (
        <div
            className={props.isSelected ? undefined : "calendar-day-selectable"}
            style={{
                ...(props.isSelected
                    ? useIsSmallScreen()
                        ? {
                              paddingLeft: 8,
                              paddingRight: 8,
                              paddingTop: 16,
                              paddingBottom: 8,
                          }
                        : {
                              paddingLeft: 16,
                              paddingRight: 16,
                              paddingTop: 16,
                              paddingBottom: 16,
                          }
                    : useIsSmallScreen()
                    ? {
                          paddingLeft: 2,
                          paddingRight: 2,
                          paddingTop: 4,
                          paddingBottom: 6,
                      }
                    : {
                          paddingLeft: 8,
                          paddingRight: 8,
                          paddingTop: 8,
                          paddingBottom: 8,
                      }),
            }}
            onClick={() => {
                if (!props.isSelected) {
                    if (isToday) {
                        setHour(
                            new Date().getHours() > 12 ? "evening" : "morning"
                        );
                    } else {
                        setHour("morning");
                    }
                    props.setDate(
                        new Date(props.year, props.month - 1, props.date)
                    );
                }
            }}
        >
            <div
                style={{
                    pointerEvents: !props.isSelected ? "none" : undefined,
                }}
            >
                <div
                    style={
                        props.isSelected
                            ? {
                                  fontWeight: "bold",
                                  fontSize: "130%",
                                  paddingLeft: 6,
                                  paddingRight: 6,
                                  lineHeight: 0.8,
                              }
                            : {
                                  fontWeight: "bold",
                                  paddingLeft: 6,
                                  paddingRight: 6,
                              }
                    }
                >
                    {
                        {
                            mon: "Monday",
                            tues: "Tuesday",
                            wed: "Wednesday",
                            thur: "Thursday",
                            fri: "Friday",
                            sat: "Saturday",
                            sun: "Sunday",
                        }[props.day]
                    }{" "}
                    {props.date}{" "}
                    {
                        [
                            "",
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December",
                        ][props.month]
                    }{" "}
                    {getOAntiphonTitle(props.month, props.date)}
                </div>

                {props.isSelected ? (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-end",
                            paddingLeft: 6,
                            paddingRight: 6,
                            paddingBottom: isToday ? 16 : 8,
                        }}
                    >
                        <div
                            style={{
                                fontSize: "130%",
                                flexGrow: 1,
                                lineHeight: 1,
                            }}
                        >
                            {hour === "morning" ? "Mattins" : "Evensong"}
                        </div>
                        {hour === "morning" ? (
                            <NewButton
                                onClick={() => {
                                    setHour("evening");
                                }}
                            >
                                Switch to Evensong
                            </NewButton>
                        ) : (
                            <NewButton
                                onClick={() => {
                                    setHour("morning");
                                }}
                            >
                                Switch to Mattins
                            </NewButton>
                        )}
                    </div>
                ) : (
                    <></>
                )}
                {props.isSelected ? (
                    <>
                        {hour === "morning" ? (
                            <>
                                <NewCelebrationList
                                    year={props.year}
                                    month={props.month}
                                    date={props.date}
                                    options={props.morningOptions}
                                    outranked={props.morningOutranked}
                                    firstEvensongList={[]}
                                    isEvening={false}
                                    isToday={isToday}
                                    compact={false}
                                    votivesNotAllowedReason={
                                        votivesNotAllowedReason
                                    }
                                />
                                {props.isFirstEvensong.length > 0 &&
                                hour === "morning" ? (
                                    <div
                                        style={{
                                            paddingTop: 16,
                                        }}
                                    >
                                        {isToday ? (
                                            <div
                                                style={{
                                                    fontWeight: "bold",
                                                    paddingLeft: 6,
                                                }}
                                            >
                                                This evening:
                                            </div>
                                        ) : (
                                            <div
                                                style={{
                                                    fontWeight: "bold",
                                                    paddingLeft: 6,
                                                }}
                                            >
                                                In the evening:
                                            </div>
                                        )}
                                        <NewCelebrationList
                                            year={props.year}
                                            month={props.month}
                                            date={props.date}
                                            options={props.eveningOptions}
                                            outranked={[]}
                                            firstEvensongList={
                                                props.isFirstEvensong
                                            }
                                            isEvening={true}
                                            isToday={false}
                                            compact={true}
                                            votivesNotAllowedReason={
                                                votivesNotAllowedReason
                                            }
                                        />
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </>
                        ) : (
                            <>
                                <NewCelebrationList
                                    year={props.year}
                                    month={props.month}
                                    date={props.date}
                                    options={props.eveningOptions}
                                    outranked={props.eveningOutranked}
                                    firstEvensongList={props.isFirstEvensong}
                                    isEvening={true}
                                    isToday={isToday}
                                    compact={false}
                                    votivesNotAllowedReason={
                                        votivesNotAllowedReason
                                    }
                                />
                            </>
                        )}
                    </>
                ) : (
                    <>
                        {/* unselected days */}
                        <NewCelebrationList
                            year={props.year}
                            month={props.month}
                            date={props.date}
                            options={props.morningOptions}
                            outranked={props.morningOutranked}
                            firstEvensongList={[]}
                            isEvening={false}
                            isToday={isToday}
                            compact={true}
                            votivesNotAllowedReason={votivesNotAllowedReason}
                        />
                        {props.isFirstEvensong.length > 0 ? (
                            <div
                                style={{
                                    paddingTop: 8,
                                }}
                            >
                                <NewCelebrationList
                                    year={props.year}
                                    month={props.month}
                                    date={props.date}
                                    options={props.eveningOptions}
                                    outranked={[]}
                                    firstEvensongList={props.isFirstEvensong}
                                    isEvening={true}
                                    isToday={false}
                                    compact={true}
                                    votivesNotAllowedReason={
                                        votivesNotAllowedReason
                                    }
                                />
                            </div>
                        ) : (
                            <></>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
